<template>
    <div>
        <CommonPopup />
        <SafetyAlarm />
    </div>
</template>

<script>
import {$_WC, $_TYPE} from '@/confs/common.const';
import commonApi from "@/apis/common.api";
import gripUtil from "@/libs/grip.util";
import SafetyAlarm from "@/views/common/SafetyAlarm";
import CommonPopup from "@/views/common/CommonPopup";

export default {
    components: {
        SafetyAlarm,
        CommonPopup,
    },
    data(){
        return {
            timestamp: 0,
            sleepTime: 60, // 초 => 자료종류 7번
            locations: [
                'main',
                'realtime',
                // 'biz',
                'lifemap',
                'indicator',
                'news',
                'read',
                'openapi',
                // 'openapi?code=01',
                // 'openapi?code=02',
                'welc',
                // 'metagn',
                // 'welcome',
            ],
            count: 0,
        }
    },
    created(){
        window.addEventListener('resize',this.setWindowWidthSize);
        this.$eventBus.$on("Swiper::slide-change", () => {
            this.setWindowWidthSize();
        });

        let timerMap = gripUtil.toDict(this.$session.get('rollerData'), 'val1');
        
        if(typeof timerMap['all'] !== 'undefined' && typeof timerMap['all'].val2 !== 'undefined') {
            this.sleepTime = Number(timerMap['all'].val2);
        }
        this.setTimestamp();
        if ($_WC.viewScale === 2) {
            // 4k비율이고 웰컴보드 페이지가 아닌 경우 롤링 한다.
            if (window.location.pathname.indexOf('/welcome') === -1) {
                setInterval(() => {
                    this.sleep();
                }, 1000 * 10);
                if (process.env.NODE_ENV === 'local') {
                    this.sleepTime = 600;
                    console.log('sleep 설정 : '+ process.env.NODE_ENV +'서버 : ' + this.sleepTime + '초');
                }
                console.log('sleep 설정 : ' + this.sleepTime + '초');
            }
        }

        // this.setTimestamp();
        // if($_WC.viewScale === 2){
        //     // 4k비율이고 웰컴보드 페이지가 아닌 경우 롤링 한다.
        //     if(window.location.pathname.indexOf('/welcome') === -1){
        //         setInterval(()=>{
        //             this.sleep();
        //         }, 1000 * 5);
        //         if(process.env.NODE_ENV === 'local') {
        //             // this.sleepTime = 3000;
        //             console.log('sleep 설정 : 서버 : ' + this.sleepTime + '초');
        //         }
        //         console.log('sleep 설정 : ' + this.sleepTime + '초');
        //     }
        // }

        this.$eventBus.$on("Swiper::touch-move", () => {
            this.setTimestamp();
        });
        this.$eventBus.$on("event-click", () => {
            this.setTimestamp();
        });
    },
    mounted() {
        window.addEventListener('touchstart', event => {
            // 터치 확대/축소 막음
            if(event.touches.length > 1) {
                event.preventDefault();
            }
        }, {passive: false});

        window.addEventListener('click', event => {
            this.setTimestamp();
        }, {passive: false});

        window.addEventListener('scroll', event => {
            this.setTimestamp();
        }, {passive: false});

        let scrolls = document.querySelectorAll(".scroll");
        scrolls.forEach(scroll => {
            scroll.addEventListener('scroll', event => {
                this.setTimestamp();
            }, {passive: false});
        });
    },
    methods: {
        setWindowWidthSize(){
            if(document.querySelector("#chartjs-tooltip") !== null) {
                document.querySelector("#chartjs-tooltip").style.opacity = 0;
                document.querySelector("#chartjs-tooltip").style.display = 'none';
            }
            this.$store.dispatch("SET_WINDOW_WIDTH_SIZE", window.innerWidth);
        },
        getTimestamp(){
            return new Date().getTime();
        },
        setTimestamp(){
            console.log('동작감지');
            this.timestamp = this.getTimestamp();
        },
        sleep(){
            this.count += 1;
            let rollerData = this.$session.get('rollerData');
            let path = window.location.pathname + window.location.search;
            if(typeof rollerData !== 'undefined' && rollerData.length > 0 && process.env.NODE_ENV !== 'local') {
                rollerData.forEach(d => {
                    // console.log('d', d);
                    if(path.indexOf(d.val1) > -1) {
                        this.sleepTime = Number(d.val2);
                        if(this.count == 1) {
                            console.log('수정된 sleep time : ' + this.sleepTime+'초');
                        }
                    }
                })
            }
            let diffTime = this.getTimestamp() - this.timestamp;
            if(diffTime > 1000 * this.sleepTime) {
            // if(diffTime > 1000 * 5) {
                this.setTimestamp();
                this.moveNext(path);
            }
        },
        moveNext(path){
            let locIdx = 0;
            let moveUrl = this.locations[locIdx];
            this.locations.forEach((loc, index) => {
                if(path.indexOf(loc) > -1){
                    locIdx = index + 1;
                }
            });
            if(typeof this.locations[locIdx] !== $_TYPE.UNDEF){
                moveUrl = this.locations[locIdx];
            }
            this.count = 0;
            location.href = $_WC.cp + moveUrl;
        },
    },
};
</script>
